import { BfaConstants } from '../constants/bfa.constants';
import { Asset } from '../models/asset.interface';

export class AssetBuilder {
	private assetClass: string = 'Other';
	private assetType: string = '';
	private commonIdentifier: string = '';
	private commonIdentifierType: string = '';
	private erroneous: boolean = false;
	private ticker: string = '';
	private identifier: string = '';
	private identifierType: string = '';
	private legalType: string = '';
	private name: string = '';
	private type: string = 'Other';
	private morningstarFundId: string = '';
	private morningstarCategory: string = '';
	private morningstarSecId: string;
	private globalId: string;
	private aladdinId: string;
	private cusip: string;
	private isin: string;
	private currency: string;
	private market: string;
	private identifiers: Map<string, string>;

	public setAssetClass(assetClass: string): AssetBuilder {
		this.assetClass = assetClass;
		return this;
	}

	public setAssetType(assetType: string): AssetBuilder {
		this.assetType = assetType;
		return this;
	}

	public setCommonIdentifier(commonIdentifier: string): AssetBuilder {
		this.commonIdentifier = commonIdentifier;
		return this;
	}

	public setCommonIdentifierType(commonIdentifierType: string): AssetBuilder {
		this.commonIdentifierType = commonIdentifierType;
		return this;
	}

	public setErroneous(errors: boolean): AssetBuilder {
		this.erroneous = errors;
		return this;
	}

	public setIdentifier(identifier: string): AssetBuilder {
		this.identifier = identifier;
		return this;
	}

	public setTicker(ticker: string): AssetBuilder {
		this.ticker = ticker;
		return this;
	}

	public setIdentifierType(identifierType: string): AssetBuilder {
		this.identifierType = identifierType;
		return this;
	}

	public setLegalType(legalType: string): AssetBuilder {
		this.legalType = legalType;
		return this;
	}

	public setName(name: string): AssetBuilder {
		this.name = name;
		return this;
	}

	public setType(type: string): AssetBuilder {
		this.type = type;
		return this;
	}

	public setMorningstarFundId(morningstarFundId: string): AssetBuilder {
		this.morningstarFundId = morningstarFundId;
		return this;
	}

	public setMorningstarCategory(morningstarCategory: string): AssetBuilder {
		this.morningstarCategory = morningstarCategory;
		return this;
	}

	public setMorningstarSecId(morningstarSecId: string): AssetBuilder {
		this.morningstarSecId = morningstarSecId;
		return this;
	}

	public setGlobalId(globalId: string): AssetBuilder {
		this.globalId = globalId;
		return this;
	}

	public setAladdinId(aladdinId: string): AssetBuilder {
		this.aladdinId = aladdinId;
		return this;
	}

	public setCusip(cusip: string): AssetBuilder {
		this.cusip = cusip;
		return this;
	}

	public setIsin(isin: string): AssetBuilder {
		this.isin = isin;
		return this;
	}

	public setCurrency(currency: string): AssetBuilder {
		this.currency = currency;
		return this;
	}

	public setMarket(market: string): AssetBuilder {
		this.market = market;
		return this;
	}

	public setIdentifiers(identifiers: Map<string, string>): AssetBuilder {
		this.identifiers = identifiers;
		return this;
	}

	public build(): Asset {
		const shouldAddTicker: boolean = this.identifierType === BfaConstants.ASSET_TICKER_IDENTIFIER_TYPE && this.identifier && !this.ticker;
		if (shouldAddTicker) {
			this.ticker = this.identifier;
		}

		const asset = new Asset();
		asset.assetClass = this.assetClass;
		asset.assetType = this.assetType;
		asset.commonIdentifier = this.commonIdentifier;
		asset.commonIdentifierType = this.commonIdentifierType;
		asset.erroneous = this.erroneous;
		asset.identifier = this.identifier;
		asset.identifierType = this.identifierType;
		asset.name = this.name;
		asset.type = this.type;
		asset.legalType = this.legalType;
		asset.ticker = this.ticker;
		asset.morningstarFundId = this.morningstarFundId;
		asset.morningstarCategory = this.morningstarCategory;
		asset.morningstarSecId = this.morningstarSecId;
		asset.globalId = this.globalId;
		asset.aladdinId = this.aladdinId;
		asset.cusip = this.cusip;
		asset.isin = this.isin;
		asset.currency = this.currency;
		asset.market = this.market;
		asset.identifiers = this.identifiers;

		return asset;
	}
}
